<template>
  <div>
    <div class="container">
      <div class="kuang">
        <div class="tit">
          <img src="@/assets/layout/titlelogo.png" alt="" />
          <div class="txt">
            <p>社科普及工作管理平台</p>
          </div>
        </div>

        <div class="tabs">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" :tab="titleName" force-render>
              <div style="padding-top: 15px">
                <a-input
                  v-model="dataInfo.userName"
                  placeholder="请输入单位名称(作为登录账号)"
                >
                </a-input>
                <div class="interval" v-if="userType=='declarator'"></div>
                <a-select   
                allowClear
                placeholder="单位所在地"
                style="width: 120px" 
                v-model="dataInfo.userCity"
                v-if="userType=='declarator'"
                >
                  <a-select-option 
                    :value="item.value" 
                    v-for="item in userCityList">
                    {{item.label}}
                  </a-select-option>
                </a-select>
                <div class="interval"></div>
                <a-input
                  v-model="dataInfo.passWord"
                  type="password"
                  placeholder="密码"
                >
                </a-input>
                <span  style="color:#bfbfbf ;font-size: 10px;font-weight: 600;padding-left: 5px;">密码要求：大写字母+小写字母+数字+特殊字符，8位以上</span>
                <div class="interval" style="height:1rem" ></div>

                <a-input
                  v-model="dataInfo.rePassWord"
                  type="password"
                  placeholder="确认密码"
                >
                </a-input>
                <div class="interval"></div>
                <a-input
                  v-model="dataInfo.chargeName"
                  placeholder="单位负责人姓名"
                >
                </a-input>
                <div class="interval"></div>
                <a-input
                  v-model="dataInfo.chargeMobile"
                  placeholder="单位负责人联系方式"
                >
                </a-input>
                <div class="interval"></div>
                <a-input
                  v-model="dataInfo.contactName"
                  placeholder="单位联系人姓名"
                >
                </a-input>
                <div class="interval"></div>
                <a-input
                  v-model="dataInfo.contactMobile"
                  placeholder="单位联系人联系方式"
                >
                </a-input>
                <!-- 修改项  selection更改  20230328 -->
                  <div class="interval"></div>
                  <a-cascader 
                  :options="cascaderList" 
                  :display-render="displayRender"
                  style="width: 368px"
                  placeholder="申报入口" 
                  :default-value= defaultValue
                  @change="cascaderChange" 
                  />

                <!-- <a-select
                  v-model="dataInfo.selsecinfo1"
                  placeholder="申报入口"
                  style="width: 120px"
                  @change="handleChange"
                >
                  <a-select-option
                    v-for="(item, i) in declareList1"
                    :key="i"
                    :value="item.id"
                  >
                    {{ item.likeName }}
                  </a-select-option>
                </a-select> -->
                <div class="interval" v-show="dataInfo.cascaderInfo =='部属、省属高校' && userType =='declarator' "></div>
                <a-select 
                  placeholder="请选择具体部属、省属高校" 
                  style="width: 120px" 
                  allowClear
                  v-model="dataInfo.secondaryDecEntrance"
                  v-show="dataInfo.cascaderInfo =='部属、省属高校' && userType =='declarator' ">
                  <!-- secDecentranceSelectList -->
                  <a-select-option 
                   v-for="item in secDecentranceSelectList"
                   :key="item.id"
                   :value="item.productUserId"
                  >
                    {{ item.unitName }}
                  </a-select-option>
                  
                </a-select>
                <span v-show="dataInfo.cascaderInfo =='部属、省属高校' && userType =='declarator' " style="color:#bfbfbf ;font-size: 10px;font-weight: 600;padding-left: 5px;">未成立社科联的高校，申报入口请选择您所在的市属</span>
                <div class="interval" style="height:1rem" v-if="dataInfo.cascaderInfo =='部属、省属高校' && userType =='declarator' " ></div>
                <div class="interval" v-else></div>
                <!-- <a-input v-model="dataInfo.bankAddress" placeholder="开户行">
                </a-input>
                <div class="interval"></div>
                <a-input v-model="dataInfo.bankName" placeholder="户名">
                </a-input>
                <div class="interval"></div>
                <a-input v-model="dataInfo.bankAccount" placeholder="银行账户">
                </a-input>
                <div class="interval"></div> -->
                <a-input
                  v-model="dataInfo.phone"
                  placeholder="请输入您的手机号"
                >
                </a-input>
                <div class="interval"></div>
                <div class="send-code" v-if="titleName == '注册账户'">
                  <a-input
                    style="width: 210px !important"
                    v-model="dataInfo.verificationCode"
                    placeholder="请输入验证码"
                  >
                  </a-input>
                  <a-button
                    v-if="!rFlag"
                    style="
                      background-color: #007651;
                      color: #fff;
                      width: 131px !important;
                    "
                    @click="sendSms"
                    >获取验证码</a-button
                  >
                  <a-button
                    v-if="rFlag"
                    disabled
                    style="
                      background-color: #007651;
                      color: #fff;
                      width: 131px !important;
                    "
                    >{{ timeValue }}秒后重新获取</a-button
                  >
                </div>
                <div class="interval" v-if="titleName == '注册账户'"></div>
                <a-input v-model="dataInfo.email" placeholder="邮箱"> </a-input>
                <div class="interval" v-if="titleName == '注册账户'"></div>
                <div class="choose" v-if="titleName == '注册账户'">
                  <p style="color: #007651" @click="registerClick(0)">去登陆</p>
                  <span>|</span>
                  <p style="color: #007651" @click="registerClick(2)">
                    忘记密码
                  </p>
                </div>
                <div class="interval"></div>
                <button class="loginbtn" @click="register" v-if="!retryRegisterFlag">
                  {{ titleName == "注册账户" ? "注册" : "确定" }}
                </button>
                <button class="loginbtn" @click="rewritePersonalInformation" v-if="retryRegisterFlag">
                  确认注册
                </button>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </div>
    <a-modal v-model="visible" title="提醒" @ok="retryRegister">
      <p>您的手机号已经在其他平台进行注册，点击确定将会覆盖原平台密码，是否确认注册？</p>
    </a-modal>
  </div>
</template>
<script>
import {
  decUserRegisterApi,
  decUserSendSmsApi,
  updateProductUserApi,
  decUserListApi
} from "@/api/declare.js";

import md5 from "js-md5";
import { validatePassword } from "@/plugins/validate";
export default {
  name: "ForgetPassword",
  data() {
    return {
      visible: false,
      retryRegisterFlag: false,
      rFlag: false,
      timeValue: 60,
      clearId: 0,
      dataInfo: {
        titleName: "注册账号",
        userName: "",
        userCity: undefined,
        passWord: "",
        rePassWord: "",
        chargeName: "" /* 单位负责人姓名 */,
        chargeMobile: "" /* 单位联系人姓名 */,
        contactName: "" /* 单位联系人姓名 */,
        contactMobile: "" /* 单位联系人手机 */,
        cascaderInfo: undefined /* 申报入口 */,
        secondaryDecEntrance:undefined /* 申报省属高校二级分类 */,
        email: "",
        phone: "",
        bankAccount: "" /* 银行账户 */,
        bankAddress: "" /* 开户行 */,
        bankName: "" /* 户名 */,
        verificationCode: "" /* 验证码 */,
        codeKey: "",
      },
      userCityList: [
      {
              value: '南京',
              label: '南京',
            },
            {
              value: '无锡',
              label: '无锡',
            },
            {
              value: '徐州',
              label: '徐州',
            },
            {
              value: '常州',
              label: '常州',
            },
            {
              value: '苏州',
              label: '苏州',
            },
            {
              value: '南通',
              label: '南通',
            },
            {
              value: '连云港',
              label: '连云港',
            },
            {
              value: '淮安',
              label: '淮安',
            },
            {
              value: '盐城',
              label: '盐城',
            },
            {
              value: '扬州',
              label: '扬州',
            },
            {
              value: '镇江',
              label: '镇江',
            },
            {
              value: '泰州',
              label: '泰州',
            },
            {
              value: '宿迁',
              label: '宿迁',
            },
      ],
      cascaderList: [
        {
          value: '省属',
          label: '省属',
          children: [
            {
              value: '部属、省属高校',
              label: '部属、省属高校',
              
            },
            {
              value: '省属机关',
              label: '省属机关',
              
            },
            {
              value: '省属学会',
              label: '省属学会',
              
            },
            {
              value: '省属企业',
              label: '省属企业',
              
            },
            
          ],
        },
        {
          value: '市属',
          label: '市属',
          children: [
            {
              value: '南京',
              label: '南京',
            },
            {
              value: '无锡',
              label: '无锡',
            },
            {
              value: '徐州',
              label: '徐州',
            },
            {
              value: '常州',
              label: '常州',
            },
            {
              value: '苏州',
              label: '苏州',
            },
            {
              value: '南通',
              label: '南通',
            },
            {
              value: '连云港',
              label: '连云港',
            },
            {
              value: '淮安',
              label: '淮安',
            },
            {
              value: '盐城',
              label: '盐城',
            },
            {
              value: '扬州',
              label: '扬州',
            },
            {
              value: '镇江',
              label: '镇江',
            },
            {
              value: '泰州',
              label: '泰州',
            },
            {
              value: '宿迁',
              label: '宿迁',
            },

          ],
        },
      ],/* 申报入口列表 */  //此处数据进行新增时，在created中会作判断，否则回显会有问题！
      secDecentranceSelectList:[],  //省属高校专属二级分类
      mobile: "", //手机号
      likeName: "", //昵称
      VerificationCode: "", //验证码
      email: "", //邮箱
      password: "", //密码
      passwords: "", //密码
      codeKey: "", //验证码串
      buttonName: "发送验证码", //发送验证码
      isDisabled: false,
      second: 60,
      defaultValue: [] ,//默认二级联动显示值
      userType:"declarator"
      
    
    };
  },
  methods: {
    // 申报入口内部两级数据处理成收集尾部
    cascaderChange(value) {
      this.dataInfo.cascaderInfo =value[1]
      console.log(value[1],value);
      if (value[1] == "部属、省属高校" && this.userType =='declarator') {
        let params = {
          userType: "cityAdm",
          pageSize: 999,
          decEntrance: "部属、省属高校",
          page: 0,
          status:1
        }
        decUserListApi(params).then((res) => {
          console.log(res.data);
           this.secDecentranceSelectList = res.data
        })
      } 
      if (value[1] == undefined  ) {
        this.dataInfo.secondaryDecEntrance = undefined
      }

      if (value[1] !== "部属、省属高校" && this.userType == 'declarator') {
        this.dataInfo.secondaryDecEntrance = undefined
      }

    },
    
    displayRender({ labels }) {
      // this.dataInfo.cascaderInfo =labels[labels.length - 1]
      return labels[labels.length - 1];
    },

    registerClick(val) {
      this.$emit("backLogin", val);
    },
    login() {
      this.$emit("goLogin", 0);
    },
    //
    countdown() {
      this.clearId = setInterval(() => {
        this.timeValue--;
        if (this.timeValue == 0) {
          clearInterval(this.clearId);
          this.timeValue = 60;
          this.rFlag = false;
        }
      }, 1000);
    },
    sendSms() {
      if (this.dataInfo.phone == "") {
        this.$message.warn("请填写您的手机号");
        return;
      }
      var reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(this.dataInfo.phone)) {
        this.$message.error("请正确填写您的手机号码！");
        this.dataInfo.phone = "";
        return;
      }
      let params = {
        mobile: this.dataInfo.phone,
      };
      decUserSendSmsApi(params).then((res) => {
        if (res.status) {
          this.$message.success(res.message);
          this.rFlag = true;
          this.countdown();

          this.dataInfo.codeKey = res.data.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    register() {
      if (this.dataInfo.userName == "") {
        this.$message.warn("请输入单位名称");
        return;
      }
      if (this.dataInfo.userCity == undefined) {
        this.$message.warn("请选择单位所在地");
        return;
      }
      if (this.dataInfo.passWord == "" && this.titleName == "注册账户") {
        this.$message.warn("请输入密码");
        return;
      }
      // 新增
    // if (!validatePassword(this.dataInfo.passWord.trim()) && this.titleName == "注册账户") {
    //     this.$message.warn(`当前添加账号不是强密码，请重新修改！密码要求：强制大写字母+小写字母+数字+特殊字符，8位以上！`);
    //     setTimeout(() => {
    //       this.dataInfo.passWord = "";
    //       this.dataInfo.rePassWord = "";
    //     },1000)
    //   return false;
    // }
    // 修改
    if (!validatePassword(this.dataInfo.passWord.trim())&& this.dataInfo.passWord != "") {
        this.$message.warn("当前账号不是强密码，请重新修改！密码要求：强制大写字母+小写字母+数字+特殊字符，8位以上！");
        setTimeout(() => {
          this.dataInfo.passWord = "";
          this.dataInfo.rePassWord = "";
        },1000)
      return false;
    }
      if (this.dataInfo.rePassWord == "" && this.titleName == "注册账户") {
        this.$message.warn("请确认密码");
        return;
      }
      if (this.dataInfo.passWord != this.dataInfo.rePassWord) {
        this.$message.error("两次密码不一致，请重新输入");
        this.dataInfo.passWord = "";
        this.dataInfo.rePassWord = "";
        return;
      }
      if (this.dataInfo.chargeName == "") {
        this.$message.warn("请输入单位负责人姓名");
        return;
      }
      if (this.dataInfo.chargeMobile == "") {
        this.$message.warn("请输入单位负责人联系方式");
        return;
      }
      if (this.dataInfo.contactName == "") {
        this.$message.warn("请输入单位联系人姓名");
        return;
      }
      if (this.dataInfo.contactMobile == "") {
        this.$message.warn("请输入单位联系人联系方式");
        return;
      }
      if (
        this.dataInfo.cascaderInfo == undefined ||
        this.dataInfo.cascaderInfo == null
      ) {
        this.$message.warn("请选择申报入口");
        return;
      }
      if (
        this.dataInfo.cascaderInfo == "部属、省属高校" &&
        this.userType =='declarator'  && this.dataInfo.secondaryDecEntrance == undefined
      ) {
        this.$message.warn("请选择具体部属、省属高校");
        return;
      }
      // if (this.dataInfo.bankAddress == "") {
      //   this.$message.warn("请输入开户行");
      //   return;
      // }
      // if (this.dataInfo.bankName == "") {
      //   this.$message.warn("请输入户名");
      //   return;
      // }
      // if (this.dataInfo.bankAccount == "") {
      //   this.$message.warn("请输入银行账户");
      //   return;
      // }
      if (this.dataInfo.phone == "") {
        this.$message.warn("请输入您的手机号");
        return;
      }
      if (
        this.titleName == "注册账户" &&
        this.dataInfo.verificationCode == ""
      ) {
        this.$message.warn("请输入验证码");
        return;
      }
      // var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      // if (!reg.test(this.dataInfo.email)) {
      //   this.$message.error("请正确填写您的邮箱！");
      //   this.dataInfo.email = "";
      //   return;
      // }
      let params = {
        bankAccount: this.dataInfo.bankAccount,
        bankName: this.dataInfo.bankAddress,
        bankUser: this.dataInfo.bankName,
        contactName: this.dataInfo.contactName,
        contactPhone: this.dataInfo.contactMobile,
        decEntrance: this.dataInfo.cascaderInfo,
        secondaryDecEntrance:this.dataInfo.secondaryDecEntrance,
        managerName: this.dataInfo.chargeName,
        managerPhone: this.dataInfo.chargeMobile,
        password: md5(this.dataInfo.passWord),
        unitName: this.dataInfo.userName,
        email: this.dataInfo.email,
        userPhone: this.dataInfo.phone,
        userName: this.dataInfo.userName,
        userCity: this.dataInfo.userCity,
        userType: "declarator",
      };
      if (this.titleName == "修改信息") {
        delete params.userType;
        if (this.dataInfo.passWord == "") {
          delete params.password;
        }
      }
      if (params.decEntrance !== '部属、省属高校') {
        params.secondaryDecEntrance = "0"
      }
      let params1 = {
        codeValue: this.dataInfo.verificationCode,
        codeKey: this.dataInfo.codeKey,
      };
      if (localStorage.getItem("userModel")) {
        params.productUserId = JSON.parse(
          localStorage.getItem("userModel")
        ).productUserId;
        params.id=JSON.parse(localStorage.getItem("userModel")).id,
        updateProductUserApi(params).then((res) => {
          if (res.status) {
            this.$message.success(res.message);
            setTimeout(() => {
              localStorage.removeItem("token");
              localStorage.removeItem("userinfo");
              localStorage.removeItem("userModel");
              sessionStorage.removeItem("userModel");
              sessionStorage.removeItem("subscribe");
              sessionStorage.removeItem("subscribeInfo");
              sessionStorage.removeItem("dyhState");
              sessionStorage.removeItem("subsId");
              //刷新页面 通过路由守卫回到登陆页
              this.$router.go(0).catch((e) => {
                console.log(e);
              });
            }, 1000);
          } else {
            console.log(typeof res.errors);
            if (
              Object.prototype.toString.call(res.errors) === "[object Object]"
            ) {
              let err = Object.values();
              this.$message.error(err);
            } else {
              this.$message.success(res.message);
            }
          }
        });
      } else {
        decUserRegisterApi(params1, params).then((res) => {
          if (res.status) {
            this.$message.success(res.message);
            setTimeout(() => {
              this.$emit("goLogin", 0);
            }, 1000);
          } else {
            if (res.data == 0) {
              this.visible = true
              
            } else {
              console.log(typeof res.errors);
              if (
                Object.prototype.toString.call(res.errors) === "[object Object]"
              ) {
                let err = Object.values(res.errors);
                this.$message.error(err);
              } else {
                this.$message.success(res.message);
              }
          }  
          }
        });
      }
    },
    // 覆盖操作
    retryRegister() {
      this.visible = false;
      this.retryRegisterFlag = true;
      this.dataInfo.verificationCode = "";
      this.dataInfo.codeKey = "";
      this.rFlag = false;
      clearInterval(this.clearId);
      this.timeValue = 60;
    },

    rewritePersonalInformation() {
      if (this.dataInfo.userName == "") {
        this.$message.warn("请输入单位名称");
        return;
      }
      if (this.dataInfo.userCity == undefined) {
        this.$message.warn("请选择单位所在地");
        return;
      }
      if (this.dataInfo.passWord == "" && this.titleName == "注册账户") {
        this.$message.warn("请输入密码");
        return;
      }
      // 新增
    // if (!validatePassword(this.dataInfo.passWord.trim()) && this.titleName == "注册账户") {
    //     this.$message.warn(`当前添加账号不是强密码，请重新修改！密码要求：强制大写字母+小写字母+数字+特殊字符，8位以上！`);
    //     setTimeout(() => {
    //       this.dataInfo.passWord = "";
    //       this.dataInfo.rePassWord = "";
    //     },1000)
    //   return false;
    // }
    // 修改
    if (!validatePassword(this.dataInfo.passWord.trim())&& this.dataInfo.passWord != "") {
        this.$message.warn("当前账号不是强密码，请重新修改！密码要求：强制大写字母+小写字母+数字+特殊字符，8位以上！");
        setTimeout(() => {
          this.dataInfo.passWord = "";
          this.dataInfo.rePassWord = "";
        },1000)
      return false;
    }
      if (this.dataInfo.rePassWord == "" && this.titleName == "注册账户") {
        this.$message.warn("请确认密码");
        return;
      }
      if (this.dataInfo.passWord != this.dataInfo.rePassWord) {
        this.$message.error("两次密码不一致，请重新输入");
        this.dataInfo.passWord = "";
        this.dataInfo.rePassWord = "";
        return;
      }
      if (this.dataInfo.chargeName == "") {
        this.$message.warn("请输入单位负责人姓名");
        return;
      }
      if (this.dataInfo.chargeMobile == "") {
        this.$message.warn("请输入单位负责人联系方式");
        return;
      }
      if (this.dataInfo.contactName == "") {
        this.$message.warn("请输入单位联系人姓名");
        return;
      }
      if (this.dataInfo.contactMobile == "") {
        this.$message.warn("请输入单位联系人联系方式");
        return;
      }
      if (
        this.dataInfo.cascaderInfo == undefined ||
        this.dataInfo.cascaderInfo == null
      ) {
        this.$message.warn("请选择申报入口");
        return;
      }
      if (
        this.dataInfo.cascaderInfo == "部属、省属高校" &&
        this.userType =='declarator'  && this.dataInfo.secondaryDecEntrance == undefined
      ) {
        this.$message.warn("请选择具体部属、省属高校");
        return;
      }
      // if (this.dataInfo.bankAddress == "") {
      //   this.$message.warn("请输入开户行");
      //   return;
      // }
      // if (this.dataInfo.bankName == "") {
      //   this.$message.warn("请输入户名");
      //   return;
      // }
      // if (this.dataInfo.bankAccount == "") {
      //   this.$message.warn("请输入银行账户");
      //   return;
      // }
      if (this.dataInfo.phone == "") {
        this.$message.warn("请输入您的手机号");
        return;
      }
      if (
        this.titleName == "注册账户" &&
        this.dataInfo.verificationCode == ""
      ) {
        this.$message.warn("请输入验证码");
        return;
      }
      // var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      // if (!reg.test(this.dataInfo.email)) {
      //   this.$message.error("请正确填写您的邮箱！");
      //   this.dataInfo.email = "";
      //   return;
      // }
      let params = {
        bankAccount: this.dataInfo.bankAccount,
        bankName: this.dataInfo.bankAddress,
        bankUser: this.dataInfo.bankName,
        contactName: this.dataInfo.contactName,
        contactPhone: this.dataInfo.contactMobile,
        decEntrance: this.dataInfo.cascaderInfo,
        secondaryDecEntrance:this.dataInfo.secondaryDecEntrance,
        managerName: this.dataInfo.chargeName,
        managerPhone: this.dataInfo.chargeMobile,
        password: md5(this.dataInfo.passWord),
        unitName: this.dataInfo.userName,
        email: this.dataInfo.email,
        userPhone: this.dataInfo.phone,
        userName: this.dataInfo.userName,
        userCity: this.dataInfo.userCity,
        userType: "declarator",
      };
      if (this.titleName == "修改信息") {
        delete params.userType;
        if (this.dataInfo.passWord == "") {
          delete params.password;
        }
      }
      if (params.decEntrance !== '部属、省属高校') {
        params.secondaryDecEntrance = "0"
      }
      let params1 = {
        codeValue: this.dataInfo.verificationCode,
        codeKey: this.dataInfo.codeKey,
      };
      params1.updatePass = 1;
      if (localStorage.getItem("userModel")) {
        params.productUserId = JSON.parse(
          localStorage.getItem("userModel")
        ).productUserId;
        params.id= JSON.parse(localStorage.getItem("userModel")).id,
        updateProductUserApi(params).then((res) => {
          if (res.status) {
            this.$message.success(res.message);
            setTimeout(() => {
              localStorage.removeItem("token");
              localStorage.removeItem("userinfo");
              localStorage.removeItem("userModel");
              sessionStorage.removeItem("userModel");
              sessionStorage.removeItem("subscribe");
              sessionStorage.removeItem("subscribeInfo");
              sessionStorage.removeItem("dyhState");
              sessionStorage.removeItem("subsId");
              //刷新页面 通过路由守卫回到登陆页
              this.$router.go(0).catch((e) => {
                console.log(e);
              });
            }, 1000);
          } else {
            console.log(typeof res.errors);
            if (
              Object.prototype.toString.call(res.errors) === "[object Object]"
            ) {
              let err = Object.values();
              this.$message.error(err);
            } else {
              this.$message.success(res.message);
            }
          }
        });
      } else {
        decUserRegisterApi(params1, params).then((res) => {
          if (res.status) {
            this.$message.success(res.message);
            setTimeout(() => {
              this.$emit("goLogin", 0);
            }, 1000);
          } else {             
              console.log(typeof res.errors);
              if (
                Object.prototype.toString.call(res.errors) === "[object Object]"
              ) {
                let err = Object.values(res.errors);
                this.$message.error(err);
              } else {
                this.$message.success(res.message);
              }
          }
        });
      }
  
    },
    //忘记密码
    secret() {
      this.$emit("forget");
    },
  },
  created() {
    if (localStorage.getItem("userModel")) {
      let obj = JSON.parse(localStorage.getItem("userModel"));
      this.titleName = "修改信息";
      this.dataInfo.userName = obj.unitName;
      this.dataInfo.userCity = obj.userCity;
      this.dataInfo.email = obj.email;
      this.dataInfo.phone = obj.userPhone;
      this.dataInfo.bankAccount = obj.bankAccount;
      this.dataInfo.bankAddress = obj.bankName;
      this.dataInfo.bankName = obj.bankUser;
      this.dataInfo.contactName = obj.contactName;
      this.dataInfo.contactMobile = obj.contactPhone;
      this.dataInfo.cascaderInfo = obj.decEntrance;
      // this.dataInfo.secondaryDecEntrance = obj.secondaryDecEntrance
      this.dataInfo.chargeName = obj.managerName;
      this.dataInfo.chargeMobile = obj.managerPhone;
      this.userType = obj.userType;

      if (this.dataInfo.cascaderInfo == "部属、省属高校" && this.userType =='declarator' ) {
        let params = {
          userType: "cityAdm",
          pageSize: 999,
          decEntrance: "部属、省属高校",
          page: 0,
          status:1,
        }
        decUserListApi(params).then((res) => {
          console.log(res.data);
          res.data.forEach((item) => {
            if (item.productUserId == obj.secondaryDecEntrance) {
              this.dataInfo.secondaryDecEntrance = item.productUserId
            }
          })
           this.secDecentranceSelectList = res.data
        })
      }

      // 因为ant的cascader不支持根据最后一级联动进行回显，所以需要直接新增数组至defaultValue中（回显使用）
      this.cascaderList.forEach((item)=>{
        item.children.forEach((li)=>{
          if (li.value === this.dataInfo.cascaderInfo) {
            this.defaultValue.push(item.value,li.value)
          }
        })
      })

    } else {
      this.titleName = "注册账户";
    }
  },
};
</script>
<style scoped lang="scss">
@import "./index.scss";
</style>
